module.exports = __webpack_public_path__ + "img/person-min.24b56bc7.png";